import { useMemo } from 'react';
import { getButtonState } from 'src/components/design-system/Button';
//import useMessageDetails from 'src/hooks/useMessageDetails';
import { MessageTrigger } from 'src/services/messages_services/useMessageDetailsApi';

const useMessageButtonState = (trigger: typeof MessageTrigger[number]) => {
  const details = '';  //...was useMessageDetails();

  //const triggerPreCheck = details?.message?.triggerPreCheck ?? [];
  const triggerPreCheck = '';

 //const [messages, buttonState] = useMemo(() => getButtonState(triggerPreCheck, trigger, MessageTrigger as unknown as string[]), [trigger, triggerPreCheck] );
 const [messages, buttonState] = useMemo(
    () => getButtonState([], trigger, MessageTrigger as unknown as string[]), [trigger, triggerPreCheck]
  );

  // Force buttonState to "default" for Undelete action
  const visibleButtonState = trigger === 'Undelete' ? 'default' : buttonState;

  return [messages, visibleButtonState] as const;
};

export default useMessageButtonState;